import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PartsRoutingModule } from './parts-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PartsRoutingModule,
    SharedModule,
    TranslateModule
  ],
  exports: [TranslateModule]
})
export class PartsModule { }